import type Pusher from "pusher-js";
import { createContext } from "react";

const PusherContext = createContext<{
  pusherInstance: Pusher | null;
  updateJwtForPusher: (token: string) => void;
}>(undefined as any);

export default PusherContext;
